import { createTheme } from '@mui/material';

export const theme = () => createTheme({
  padding: '0 40px',
  backgroundColor: '#252525',
});
